import { axiosInstanceAuth } from "./client"
import { useMutation } from '@tanstack/react-query';
import { ErrorResponse, User, IResponseStatus, IRequestUpdateStatus } from "interfaces"
import { AxiosError } from "axios";
import dayjs from 'dayjs';

export const useGetUserByTag = (onOk?: Function, onErr?: Function) => {
	return useMutation<
		{ data: User },
		AxiosError<ErrorResponse>,
		{ code: string; location_code: string; section_code: string }
	>({
		mutationKey: ["GET USER BY TAG"],
		mutationFn: async ({
			code,
			location_code,
			section_code,
		}: {
			code: string;
			location_code: string;
			section_code: string;
		}) =>
			axiosInstanceAuth.post(
				"/tags/handle_efc",
				JSON.stringify({
					version: 2.5,
					status: 1,
					data: {
						version: "2.5",
						event_name: "Came_Here",
						confidence: 1,
						device_code: "99",
						event_value: "1",
						section_code: section_code,
						location_code: location_code,
						customer_tag_id: code,
						edge_bridge_id: "WM0000000001",
						event_created_at: dayjs().valueOf(),
					},
				})
			),
		onSuccess: (res, variables) => {
			onOk && onOk(res, variables);
		},
		onError: (err: AxiosError<ErrorResponse>) => {
			onErr && onErr(err);
		},
	});
};

export const useCheckStatus = (onOk?: Function , onErr?:Function) => {
    return useMutation<{data: IResponseStatus}, AxiosError<ErrorResponse>, string>({
        mutationKey: ['GET STATUS'],
        mutationFn: () => axiosInstanceAuth.get('/status'),
        onSuccess: (_res) => {
            onOk && onOk(_res)

        },
        onError: (err: AxiosError<ErrorResponse>) => {
            onErr && onErr(err)
        },
        retry: false,
    })
}

export const useUpdateStatus = (onOk?: Function , onErr?:Function) => {
    return useMutation({
        mutationKey: ['UPDATE STATUS'],
        mutationFn: (body:IRequestUpdateStatus) => axiosInstanceAuth.put('/status/change_status', body),
        onSuccess: () => {
            onOk && onOk()
        },
        onError: (err: AxiosError<ErrorResponse>) => {
            onErr && onErr(err)
        }
    })
}
